import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const MenuItemSymbol = ({ symbol, theme, className }) => (
  <span
    className={cx(
      'h-5 w-6 flex items-center justify-center uppercase text-2xs font-medium text-gray',
      {
        'bg-gray-darker': theme === 'dark',
        'bg-gray-dark': theme === 'light',
      },
      className
    )}
  >
    {symbol}
  </span>
);

MenuItemSymbol.propTypes = {
  symbol: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
};

MenuItemSymbol.defaultProps = {
  theme: 'dark',
  className: '',
};

export default MenuItemSymbol;
